import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
  faExclamationTriangle,
  faInfoCircle, // Tambahkan ikon untuk info
} from "@fortawesome/free-solid-svg-icons";

export const NotificationModal = ({ isOpen, onClose, type, message }) => {
  if (!isOpen) return null;

  const typeStyles = {
    success: {
      border: "border-slate-100",
      icon: faCheckCircle,
      textColor: "text-cyan-600",
    },
    error: {
      border: "border-slate-100",
      icon: faTimesCircle,
      textColor: "text-red-600",
    },
    warning: {
      border: "border-slate-100",
      icon: faExclamationTriangle,
      textColor: "text-yellow-600",
    },
    info: {
      border: "border-slate-100",
      icon: faInfoCircle,
      textColor: "text-blue-600", // Warna untuk info
    },
  };

  const { border, icon, textColor } = typeStyles[type] || typeStyles.success;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300">
      <div
        className={`bg-white rounded-xl p-6 max-w-sm w-full mx-4 border-2 ${border} transform transition-transform duration-300 scale-100`}
      >
        <div className="flex items-center mb-4">
          <FontAwesomeIcon icon={icon} className={`text-2xl ${textColor}`} />
        </div>
        <p className="text-gray-600 mb-6">{message}</p>
        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-cyan-600 text-white rounded-xl hover:bg-cyan-700 transition-colors duration-200"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

NotificationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["success", "error", "warning", "info"]).isRequired, // Tambahkan "info"
  message: PropTypes.string.isRequired,
};
